/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  document.addEventListener("DOMContentLoaded", function () {
    const headerElem = document.querySelector("header.theme__header");
  
    if (headerElem) {
      const headerWrapper = headerElem.parentElement;
      const desktopHeaderElem = headerElem.querySelector(".header__desktop");
      const mobileHeaderElem = headerElem.querySelector(".header__mobile");
  
      if (desktopHeaderElem) {
        const togglableMenuElems = desktopHeaderElem.querySelectorAll(
          ".menu__item.grandparent"
        );
  
        const dropdownOpenClass = "open";
        let openedDropdownElem = null;
        const closeWhenOnTargets = [];

        const headerWrapperOpenClass = "meganav--visible";
        const toggleInitialOpenClass = "is-visible";

        const dropdownInitialOpenClass = "is-visible";
  
        const headerLogoElem = desktopHeaderElem.querySelector(".header__logo");
        const headerButtonsElem = desktopHeaderElem.querySelector(
          ".header__desktop__buttons"
        );

        let closeTimeoutId = null;
  
        closeWhenOnTargets.push(
          headerLogoElem,
          headerButtonsElem,
          mobileHeaderElem
        );
        
        const closeDropDown = () => {
          openedDropdownElem?.classList.remove(dropdownOpenClass, dropdownInitialOpenClass);
          openedDropdownElem?.parentElement.setAttribute("aria-expanded", false);
          openedDropdownElem?.parentElement.classList.remove(toggleInitialOpenClass);
          openedDropdownElem = null;
        };
  
        const openDropDown = (dropdown) => {
          dropdown.classList.add(dropdownOpenClass, dropdownInitialOpenClass);
          dropdown.parentElement.setAttribute("aria-expanded", true);
          dropdown.parentElement.classList.add(toggleInitialOpenClass);
          openedDropdownElem = dropdown;
        };
  
        const replaceDropdown = (dropdown) => {
          openedDropdownElem.classList.remove(dropdownOpenClass, dropdownInitialOpenClass);
          openedDropdownElem.parentElement.setAttribute("aria-expanded", false);
          openedDropdownElem?.parentElement.classList.remove(toggleInitialOpenClass);
          
          openedDropdownElem = dropdown;
          dropdown.classList.add(dropdownOpenClass, dropdownInitialOpenClass);
          dropdown.parentElement.setAttribute("aria-expanded", true);
          dropdown.parentElement.classList.add(toggleInitialOpenClass);
        };
  
        togglableMenuElems.forEach((elem) => {
          // remove initial event listeners
          const elemCopy = elem.cloneNode(true);
          elem.replaceWith(elemCopy);

          const link = elemCopy.querySelector(":scope > a.navlink.navlink--toplevel");
          const dropdown = elemCopy.querySelector(":scope > .header__dropdown");

          elemCopy.addEventListener("click", (event) => {
            event.stopImmediatePropagation();
            if (!openedDropdownElem) {
              openDropDown(dropdown);
            } else if (openedDropdownElem !== dropdown) {
              replaceDropdown(dropdown);
            } else {
              closeDropDown();
            }
          }, false);        
  
          link?.addEventListener("click", (event) => {
            event.preventDefault();
          });

          const enterHandler = () => {
            headerWrapper.classList.add(headerWrapperOpenClass);
            if (closeTimeoutId) {
              clearTimeout(closeTimeoutId);
              closeTimeoutId = null;
            }
            if (openedDropdownElem && openedDropdownElem !== dropdown) {
              replaceDropdown(dropdown);
            }
          }

          const leaveHandler = () => {
            headerWrapper.classList.remove(headerWrapperOpenClass);
            closeTimeoutId = setTimeout(() => {
              closeTimeoutId = null;
              closeDropDown();
            }, 80);
          }
  
          elemCopy.addEventListener("mouseenter", enterHandler);
          elemCopy.addEventListener("focusin", enterHandler);

          elemCopy?.addEventListener("focusout", leaveHandler);      
          elemCopy?.addEventListener("mouseleave", leaveHandler);
        });
  
        headerElem.addEventListener("mouseleave", () => {
          closeDropDown();
        });
  
        closeWhenOnTargets.forEach((elem) => {
          elem.addEventListener("mouseenter", () => {
            closeDropDown();
          });
        });
  
        document.addEventListener("click", (event) => {
          closeDropDown();
        });
      }
    }
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
